<template>
  <div class="article-action">
    <Favorite :book="article"></Favorite> {{ $t("favorite") }}
    <span class="muted">|</span>
    <span>{{ article.pv }} {{ $t("views") }}</span>
    <span v-if="isAuthor">
      <span class="muted">|</span>
      <span @click="edit" class="pointer"
        ><ui-icon name="icon-edit-square"></ui-icon>{{ $t("edit") }}</span
      >
      <span class="muted">|</span>
      <span @click="del" class="pointer"
        ><ui-icon name="icon-delete"></ui-icon>{{ $t("delete") }}</span
      >
    </span>
  </div>
</template>
<script>
import api from "../../api/index";
import Favorite from "../Favorite.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Favorite
  },
  computed: {
    ...mapGetters(["authInfo"]),
    isAuthor() {
      return this.authInfo && this.authInfo.id === this.article.userInfo.id;
    }
  },
  props: ["article", "contentHeight"],
  methods: {
    edit() {
      this.$router.push("/article/edit/" + this.article.id);
    },
    del() {
      let id = this.article.id;
      this.$UiConfirm({
        header: this.$t("deleteArticleConfirm"),
        content: this.$t("deleteArticleMessage"),
        cance: this.$t("cancel"),
        confirm: this.$t("delete"),
        onConfirm: () => {
          api
            .delBook(id)
            .then(res => {
              this.$router.go(-1);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  }
};
</script>
